@if (report) {
<div class="report-header">
  <div class="rh-left">
    <div class="rh-title">
      <h1 class="rh-title-h1">{{report.baer_name}} ({{report.report_num}})</h1>
    </div>
    <div class="rh-sub">
      2500-8 Report ID: {{report.report_id}}
      <span class="pipe-color"> | </span>
      Action: {{report.report_num == 0 ? "Pre-assessment" : report.report_num == 1 ? "Initial" : "Interim"}}
      <span class="pipe-color"> | </span>
      Report
      Status: <mat-chip [ngClass]="'chip-r-'+report.report_status_id">{{report.report_status_id |
        reportStatusBadge}}</mat-chip>
      @if (report.report_status_id == 2) {
      <span class="spacer">|</span>Authorization Status:
      <mat-chip [ngClass]="'chip-a-'+report?.authorization_status_id">
        {{report.authorization_status_id | authorizationStatusBadge}}
      </mat-chip>
      }
      @if (report.page_1_status_id == 2 && report.page_2_status_id == 2 && report.page_3_status_id == 2) {
      <span class="spacer">|</span>
      <a (click)="download(report.report_id)" class="export-header">
        <fa-icon class="fa-sm" [icon]="faFileArrowDown"></fa-icon>
        <span>Export PDF</span>
      </a>
      }
    </div>
  </div>
  <div class="rh-right">
    @if (autosave.saving && nav() == '') {
    <div class="save-info-div">
      <div>
        <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
      </div>
      Saving...
    </div>
    }
    @if (nav() != '') {
    <div class="save-info-div">
      <div>
        <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
      </div>
      Saving...
    </div>
    }
    @if (autosave.saved && nav() == '') {
    <div class="save-info-div">
      <fa-icon [icon]="faCheck" class="save-check" aria-label="check"></fa-icon>
      {{ savedText }}
    </div>
    }
    @if (report_page != maxPage+1) {
    <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent">Save &
      Close</button>
    }
    @if (report_page == maxPage+1) {
    <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent">Close</button>
    }
  </div>
</div>
}
@if (report) {
<div class="report-main">
  @if (report_page != maxPage+1) {
  <div class="report-nav">
    <div class="rnav-header">
      <div>2500-8 Report</div>
    </div>
    @for (name of pageNames; track name; let page = $index) {
    <div
      [ngClass]="'rnav-item rnav-status-'+(report_page==(page+1) ? (current_status ?? report['page_'+(page+1)+'_status_id']) : report['page_'+(page+1)+'_status_id']) +' rnav-current-'+(report_page==page+1)">
      <button class="anchor-button" (click)="goToPage(page+1)">
        <div>
          @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 1) ||
          (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 1)){
          <mat-icon class="current-page">contrast</mat-icon>
          }
          @else {
          @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 2) ||
          (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 2)) {
          <mat-icon>check_circle</mat-icon>
          }
          @else {<mat-icon>panorama_fish_eye</mat-icon>}
          }
          {{page+1}}. {{name}}
        </div>
      </button>
    </div>
    }
  </div>
  }
  <div class="report-right-area">
    <div class="report-area">
      @if (report && report_type != 'No Treatment' && report_type != 'Pre-assessment Request') {
      <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''">
        @if(report_page != maxPage+1) {
        <ng-container *ngTemplateOutlet="underReview"></ng-container>
        }
        @switch (report_page) {
        @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
        @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
        @case (3) {<app-watershed-condition [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-watershed-condition>}
        @case (4) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
        @case (5) {<app-recommended-treatment [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-recommended-treatment>}
        @case (6) {<app-emergency-stabilization [report]="report" [(nav)]="nav" page="6" (status)="statusChange($event)"
          (loaded)="subLoaded()"></app-emergency-stabilization>}
        @case (7) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-team-supporting>}
        @case (8) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
        @case (9) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co" (status)="statusChange($event)"
          (loaded)="subLoaded()"></app-submission>}
        @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
        }
      </div>
      }
      @if (report && report_type == 'No Treatment') {
      <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''">
        @if(report_page != maxPage+1) {
        <ng-container *ngTemplateOutlet="underReview"></ng-container>
        }
        @switch (report_page) {
        @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
        @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
        @case (3) {<app-watershed-condition [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-watershed-condition>}
        @case (4) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
        @case (5) {<app-assessment-cost [report]="report" [(nav)]="nav" (status)="statusChange($event)"
          (loaded)="subLoaded()"></app-assessment-cost>}
        @case (6) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
          (status)="statusChange($event)" (loaded)="subLoaded()" page="6"></app-team-supporting>}
        @case (7) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co" page="7"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
        @case (8) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co"
          (loaded)="subLoaded()"></app-submission>}
        @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
        }
      </div>
      }
      @if (report && report_type == 'Pre-assessment Request') {
      <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''">
        @if(report_page != maxPage+1) {
        <ng-container *ngTemplateOutlet="underReview"></ng-container>
        }
        @switch (report_page) {
        @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
        @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave" [simple]="true"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
        @case (3) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave" [simple]="true" page="3"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
        @case (4) {<app-recommended-treatment [report]="report" [(nav)]="nav" [autosave]="autosave"
          (status)="statusChange($event)" page="4" (status)="statusChange($event)"
          (loaded)="subLoaded()"></app-recommended-treatment>}
        @case (5) {<app-emergency-stabilization [report]="report" [(nav)]="nav" page="5" (status)="statusChange($event)"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-emergency-stabilization>}
        @case (6) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true" page="6"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-team-supporting>}
        @case (7) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co" page="7"
          (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
        @case (8) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co"
          (loaded)="subLoaded()"></app-submission>}
        @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
        }
      </div>
      }
      @if (report_page != maxPage+1) {
      <div class="report-comments" [ngClass]="comment_expand ? 'expand-comment' : ''">
        @if(comments_unresolved) {
        @if (!comment_expand) {
        <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true">
          <fa-icon [icon]="faMessage" class="chat-count-red" aria-label="chat"></fa-icon><span
            class="button-text chat-text-red">{{comments?.length ?? 0}}</span>
        </button>
        }
        } @else {
        @if (!comment_expand) {
        <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true">
          <fa-icon [icon]="faMessage" class="chat-count" aria-label="chat"></fa-icon><span
            class="button-text chat-text">{{comments?.length ?? 0}}</span>
        </button>
        }
        }
        @if (comment_expand) {
        <div class="comment-header">
          <button class="comment-button">
            Comments<span>({{comments?.length ?? 0}})</span></button>
          @if (comment_expand && is_co) {
          <button class="comment-add-button" (click)="addComment()" matTooltip="Add comment"
            matTooltipClass="tooltipClass">
            <mat-icon>add</mat-icon></button>
          }
          <button mat-icon-button class="icon-button" (click)="comment_expand = false" matTooltip="Hide comments"
            matTooltipClass="tooltipClass" matTooltipPosition="left"><mat-icon>keyboard_tab</mat-icon></button>
        </div>
        }
        @if (comment_expand && ((comments?.length ?? 0) == 0)) {
        <div class="no-comments">
          <fa-icon [icon]="faCommentSlash" class="chat-count" aria-label="no messages"></fa-icon>
          <div class="no-comments-title">No Comments</div>
          @if (!is_co) {
          <div class="no-comments-text">
            No revisions have been requested
          </div>
          }
          @if (is_co) {
          <div class="no-comments-text">
            Leave a comment to request revisions to the report
          </div>
          }
          @if (comment_expand && is_co) {
          <button class="comment-add-button" (click)="addComment()"><mat-icon>add</mat-icon> Add Comment</button>
          }
        </div>
        }
        @if (comment_expand && ((comments?.length ?? 0) > 0)) {
        <div class="comments">
          @for(comment of comments; track comment) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                <button class="anchor-button" (click)="goToPage(comment.section)">
                  {{comment.section}}. {{findPage(comment.section) }}
                </button>
              </mat-card-title>
              <div class="comment-title-align">
                @if (comment.resolved && is_co) {
                <mat-icon class="resolved" matTooltip="Resolved" matTooltipClass="tooltipClass"
                  matTooltipPosition="left">check</mat-icon>
                }
                @if (!is_co && !comment.resolved) {
                <button class="resolve-button" mat-icon-button (click)="markAsResolved(comment, true)"
                  aria-label="Mark as Resolved" matTooltip="Mark as Resolved" matTooltipClass="tooltipClass"
                  matTooltipPosition="left">
                  <mat-icon class="unresolved-icon">panorama_fish_eye</mat-icon>
                </button>
                }
                @if (!is_co && comment.resolved) {
                <button class="resolve-button" mat-icon-button (click)="markAsResolved(comment, false)"
                  aria-label="Mark as Unresolved" matTooltip="Mark as Unresolved" matTooltipClass="tooltipClass"
                  matTooltipPosition="left">
                  <mat-icon class="resolved-icon">check</mat-icon>
                </button>
                }
                @if (is_co) {
                <button class="comment-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Comment Menu"
                  matTooltip="Actions menu" matTooltipClass="tooltipClass" matTooltipPosition="left">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                }
                <mat-menu #menu="matMenu">
                  <button class="comment-edit" mat-menu-item (click)="editComment(comment)">
                    <fa-icon class="fa-sm" [icon]="faEdit" style="color: #216E1F;"></fa-icon>
                    <span>Edit</span>
                  </button>
                  <button class="comment-delete" mat-menu-item (click)="deleteComment(comment)">
                    <fa-icon class="fa-sm" [icon]="faTrash"></fa-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
            </mat-card-header>
            <mat-card-content>
              <span class="comment-info"><b>{{comment.commentator_name}}</b> • {{comment.updated_on |
                date:"MM/dd/yyyy"}}</span>
              <span class="comment-detail">{{comment.comment}}</span>
            </mat-card-content>
          </mat-card>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (report_page != (maxPage + 1)) {
    <div class="report-footer" style="z-index: 1000;">
      <div class="rf-left">
        @if (report_page > 1) {
        <button class="nav-btn" (click)="back()"><mat-icon>arrow_back_ios</mat-icon>{{report_page - 1}}.
          {{pageNames[report_page - 2]}}</button>
        }
      </div>
      <div class="rf-right">
        @if (report_page == maxPage) {
        @if (is_lead && report.report_status_id == 0 && report.authorization_status_id == null) {
        <button class="submit-btn" (click)="forward()" color="accent" [disabled]="
                report.page_1_status_id != 2 ||
                report.page_2_status_id != 2 ||
                report.page_3_status_id != 2 ||
                report.page_4_status_id != 2 ||
                report.page_5_status_id != 2 ||
                report.page_6_status_id != 2 ||
                report.page_7_status_id != 2 ||
                (maxPage >= 8 && report.page_8_status_id != 2 )
                "><span>Send for Review</span>
          <mat-icon>send</mat-icon></button>
        }
        @if (is_co && report.report_status_id == 3 && report.authorization_status_id == null) {
        <button class="submit-btn" (click)="forward()" color="accent" [disabled]="unresolved"
          matTooltip="All feedback must be fixed and completed before requesting a final report."
          matTooltipClass="tooltipClass"><span>Request Final Report</span>
          <mat-icon>send</mat-icon></button>
        }
        @if (report.report_status_id == 1) {
        <button class="submit-btn" (click)="forward()" color="accent" [disabled]="unresolved || !complete"><span>Send
            Final Report</span>
          <mat-icon>send</mat-icon></button>
        }
        } @else {
        <button class="nav-btn" (click)="forward()">{{report_page + 1}}.
          {{pageNames[report_page]}}<mat-icon>arrow_forward_ios</mat-icon></button>
        }
      </div>
    </div>
    }
  </div>
</div>
}

<ng-template #underReview>
  @if (report.report_status_id == 3 && !is_co) {
  <div class="yellow-warning">
    <fa-icon [icon]="faFile" class="faFile" aria-label="Warning"></fa-icon>
    <div class="support-text">
      <b>The report is under review by the Regional BAER Coordinator.</b>
      <span>
        <br>
      </span>
      If additional information or changes are requested you will be notified in the Comments sidebar.
    </div>
  </div>
  }
</ng-template>